const SplitArrows = () => (
  <>
    <path
      fill="currentColor"
      d="M16.292 6H13.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.213.144-.356A.49.49 0 0 1 13.5 5h3.692q.344 0 .576.232a.78.78 0 0 1 .232.576V9.5q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144A.49.49 0 0 1 17 9.5V6.708l-5.313 5.313a1.66 1.66 0 0 1-1.15.479H4.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 4.5 11.5h6.042q.115 0 .222-.039a.6.6 0 0 0 .202-.134zm0 12-3.494-3.488a.5.5 0 0 1-.156-.348.48.48 0 0 1 .156-.366q.165-.165.36-.165t.36.165L17 17.292V14.5q0-.213.144-.356a.49.49 0 0 1 .357-.144q.212 0 .356.144A.48.48 0 0 1 18 14.5v3.692q0 .344-.232.576a.78.78 0 0 1-.576.232H13.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 13.5 18z"
    />
  </>
)
export default SplitArrows
